import React, { useState, useEffect } from "react";
import { Stack, TextField, Typography, Table, TableContainer, TableHead, TableRow, TableCell, TableBody, Paper } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import useGetStepSchemes from "../../hooks/useGetStepSchemes";
import { useSelector } from "react-redux";
import useUpdateStepScheme from "../../hooks/useUpdateStepScheme";
import { getCompanyStepSchemesData, getVitaranStepSchemesData } from "../../slice/coinSlice";
import { useDispatch } from "react-redux";

const RewardCoinsTable = () => {
  const getCompanySchemes = useGetStepSchemes('company');
  const getVitaranSchemes = useGetStepSchemes('vitaran');
  const updateScheme = useUpdateStepScheme();
  const dispatch = useDispatch();
  // Separate state for Vitaran and Company data
  const [vitaranRewardData, setVitaranRewardData] = useState([]);
  const [vitaranEditedData, setVitaranEditedData] = useState([]);
  const [companyRewardData, setCompanyRewardData] = useState([]);
  const [companyEditedData, setCompanyEditedData] = useState([]);

useEffect(() => {
  const fetchData = async () => {
    try {

      // 2️⃣ Then fetch Vitaran schemes
      const vitaranDataRes = await getVitaranSchemes();
      const vitaranList = vitaranDataRes?.schemes_list || [];
      const processedVitaran = vitaranList.some(
        item => !item.value || item.value.length < 25
      )
        ? ensure25Values(vitaranList)
        : vitaranList;

      // Save vitaran data next
      setVitaranRewardData(processedVitaran);

      
      // 1️⃣ Fetch Company schemes first
      const companyDataRes = await getCompanySchemes();
      const companyList = companyDataRes?.schemes_list || [];
      const processedCompany = companyList.some(
        item => !item.value || item.value.length < 25
      )
        ? ensure25Values(companyList)
        : companyList;

      // Save company data first
      setCompanyRewardData(processedCompany);

      

      // console.log("✅ Data fetched successfully:", {
      //   companyRows: processedCompany.length,
      //   vitaranRows: processedVitaran.length,
      // });
    } catch (error) {
      console.error("❌ Error fetching step schemes:", error);
    }
  };

  fetchData();
}, []);

  // const companySchemes = useSelector((state) => state.coin.companyStepScheme);
  // const vitaranSchemes = useSelector((state) => state.coin.vitaranStepScheme);

    const ensure25Values = (data) => {
      // console.log("Ensuring 25 values for data:", data);
    return data.map(item => {
      // If value array is null or empty, create 25 objects
      if (!item.value || item.value.length === 0) {
        return {
          ...item,
          value: Array.from({ length: 25 }, (_, index) => ({
            step_index: index + 1,
            creditable_value: null,
            id: index + 1
          }))
        };
      }

      // If value array has less than 25 objects, add the remaining ones
      if (item.value.length < 25) {
        const existingValues = [...item.value];
        const missingCount = 25 - existingValues.length;

        const newValues = Array.from({ length: missingCount }, (_, index) => ({
          step_index: existingValues.length + index + 1,
          creditable_value: null,
          id: existingValues.length + index + 1
        }));

        return {
          ...item,
          value: [...existingValues, ...newValues]
        };
      }

      // If already has 25 or more, just return as is
      return item;
    });
  };

  useEffect(() => {
    if (vitaranRewardData && vitaranRewardData.length > 0) {
    setVitaranEditedData(vitaranRewardData.map(item => ({
      ...item,
      value: item.value.map(val => ({ ...val }))
    })));
    }
  }, [vitaranRewardData]);

  useEffect(() => {
    if (companyRewardData && companyRewardData.length > 0) {
    setCompanyEditedData(companyRewardData.map(item => ({
      ...item,
      value: item.value.map(val => ({ ...val }))
    })));
    }
  }, [companyRewardData]);

//   useEffect(() => {
//   if (vitaranSchemes && vitaranSchemes.length > 0) {
//     const shouldEnsure = vitaranSchemes.some(
//       item => !item.value || item.value.length < 25
//     );
//     if (shouldEnsure) {
//       const processedData = ensure25Values(vitaranSchemes);
//       setVitaranRewardData(processedData);
//     } else {
//       setVitaranRewardData(vitaranSchemes);
//     }
//   }
// }, [vitaranSchemes]);

// useEffect(() => {
//   if (companySchemes && companySchemes.length > 0) {
//     const shouldEnsure = companySchemes.some(
//       item => !item.value || item.value.length < 25
//     );
//     if (shouldEnsure) {
//       const processedData = ensure25Values(companySchemes);
//       setCompanyRewardData(processedData);
//     } else {
//       setCompanyRewardData(companySchemes);
//     }
//   }
// }, [companySchemes]);

  const handleVitaranInputChange = (rowIndex, valueIndex, field, value) => {
    const updatedData = [...vitaranEditedData];
    const numericValue = value === "" ? null : parseFloat(value);

    updatedData[rowIndex].value[valueIndex] = {
      ...updatedData[rowIndex].value[valueIndex],
      [field]: numericValue
    };

    setVitaranEditedData(updatedData);
  };

  const handleCompanyInputChange = (rowIndex, valueIndex, field, value) => {
    const updatedData = [...companyEditedData];
    const numericValue = value === "" ? null : parseFloat(value);

    updatedData[rowIndex].value[valueIndex] = {
      ...updatedData[rowIndex].value[valueIndex],
      [field]: numericValue
    };

    setCompanyEditedData(updatedData);
  };

  const handleVitaranMinSkuSizeChange = (index, value) => {
    const numericValue = value === "" ? null : parseInt(value, 10);
    const updatedData = [...vitaranEditedData];
    updatedData[index] = { ...updatedData[index], min_sku_size: numericValue };
    setVitaranEditedData(updatedData);
  };

  const handleCompanyMinSkuSizeChange = (index, value) => {
    const numericValue = value === "" ? null : parseInt(value, 10);
    const updatedData = [...companyEditedData];
    updatedData[index] = { ...updatedData[index], min_sku_size: numericValue };
    setCompanyEditedData(updatedData);
  };

  const handleVitaranSubmit = async () => {
    const hasEmptyValues = vitaranEditedData.some(item =>
      item.min_sku_size === null || item.min_sku_size === 0 ||
      item.value.some(val =>
        val.creditable_value === null || val.creditable_value === 0
      )
    );

    if (hasEmptyValues) {
      toast.error("All fields are required and must be greater than 0");
      return;
    }

    const apiData = vitaranEditedData.map(item => ({
      sku_ids: item.sku_ids || [],
      name: item.price != null ? String(item.price) : "",
      min_sku_size: item.min_sku_size,
      steps: item.value.map(val => ({
        step_index: val.step_index,
        creditable_value: val.creditable_value
      }))
    }));

    try {
      await updateScheme({
        scheme_sponsor: 'vitaran',
        schemes: apiData
      });
      toast.success("Vitaran data updated successfully");
    } catch (error) {
      console.error("Error updating Vitaran schemes:", error);
      toast.error("Failed to update Vitaran data");
    }
  };

  const handleCompanySubmit = async () => {
    const hasEmptyValues = companyEditedData.some(item =>
      item.min_sku_size === null || item.min_sku_size === 0 ||
      item.value.some(val =>
        val.creditable_value === null || val.creditable_value === 0
      )
    );

    if (hasEmptyValues) {
      toast.error("All fields are required and must be greater than 0");
      return;
    }

    const apiData = companyEditedData.map(item => ({
      sku_ids: item.sku_ids || [],
      name: item.price != null ? String(item.price) : "",
      min_sku_size: item.min_sku_size,
      steps: item.value.map(val => ({
        step_index: val.step_index,
        creditable_value: val.creditable_value
      }))
    }));

    try {
      await updateScheme({
        scheme_sponsor: 'company',
        schemes: apiData
      });
      toast.success("Company data updated successfully");
    } catch (error) {
      console.error("Error updating Company schemes:", error);
      toast.error("Failed to update Company data");
    }
  };

  return (
    <Stack
      sx={{
        width: "100%",
        height: "100%",
        padding: "5px 5px",
        maxWidth: "calc(100vw - 120px)",
      }}
    >
      {/* Vitaran Table */}
      <Stack>
        <Typography sx={{ textAlign: "left", fontSize: "24px" }}>
          Spin by Vitaran
        </Typography>
        <TableContainer
          component={Paper}
          sx={{
            marginTop: 2,
            borderRadius: "10px",
            border: "1px solid gray",
            maxHeight: "60vh",
          }}
        >
          <Table stickyHeader aria-label="reward coins table">
            <TableHead>
              <TableRow sx={{ backgroundColor: "#c4c4c4" }}>
                <TableCell
                  sx={{
                    backgroundColor: "#c4c4c4",
                    textAlign: "center",
                    minWidth: "150px",
                  }}
                >
                  SKU Names
                </TableCell>
                <TableCell
                  sx={{
                    backgroundColor: "#c4c4c4",
                    textAlign: "center",
                    minWidth: "100px",
                  }}
                >
                  Min. SKU Qty
                </TableCell>
                {vitaranEditedData?.[0]?.value?.map((_, index) => (
                  <TableCell
                    sx={{
                      backgroundColor: "#c4c4c4",
                      textAlign: "center",
                      minWidth: "60px",
                    }}
                    key={index}
                  >
                    CV {index + 1}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {vitaranEditedData?.map((row, rowIndex) => (
                <TableRow key={row.id}>
                  <TableCell sx={{ textAlign: "center" }}>
                    {row.sku_names.join(", ")}
                  </TableCell>
                  <TableCell
                    sx={{ textAlign: "center", backgroundColor: "#e8e6e6ff" }}
                  >
                    <TextField
                      size="small"
                      type="number"
                      inputProps={{ min: 1 }}
                      value={row.min_sku_size}
                      onChange={(e) =>
                        handleVitaranMinSkuSizeChange(rowIndex, e.target.value)
                      }
                      error={row.min_sku_size === ""}
                      helperText={
                        row.min_sku_size === "" ? "This Field is required" : ""
                      }
                    />
                  </TableCell>
                  {row?.value?.map((val, valueIndex) => (
                    <React.Fragment key={val.id}>
                      <TableCell sx={{ textAlign: "center" }}>
                        <TextField
                          size="small"
                          type="number"
                          inputProps={{ min: 1 }}
                          value={val.creditable_value}
                          onChange={(e) =>
                            handleVitaranInputChange(
                              rowIndex,
                              valueIndex,
                              "creditable_value",
                              e.target.value
                            )
                          }
                          error={val.creditable_value === ""}
                          helperText={
                            val.creditable_value === ""
                              ? "This Field is required"
                              : ""
                          }
                        />
                      </TableCell>
                    </React.Fragment>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Stack sx={{ justifyContent: "center", marginTop: 2 }}>
          <button
            onClick={handleVitaranSubmit}
            style={{
              backgroundColor: "#DC1D13",
              color: "white",
              padding: "10px 18px",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              textTransform: "none",
              width: "fit-content",
              alignSelf: "center",
            }}
          >
            <strong>Update</strong>
          </button>
        </Stack>
        <ToastContainer />
      </Stack>

      {/* Company Table */}
      <Stack>
        <Typography sx={{ textAlign: "left", fontSize: "24px" }}>
          Spin by Company
        </Typography>
        <TableContainer
          component={Paper}
          sx={{
            marginTop: 2,
            borderRadius: "10px",
            border: "1px solid gray",
            maxHeight: "60vh",
          }}
        >
          <Table stickyHeader aria-label="reward coins table">
            <TableHead>
              <TableRow sx={{ backgroundColor: "#c4c4c4" }}>
                <TableCell
                  sx={{
                    backgroundColor: "#c4c4c4",
                    textAlign: "center",
                    minWidth: "150px",
                  }}
                >
                  SKU Names
                </TableCell>
                <TableCell
                  sx={{
                    backgroundColor: "#c4c4c4",
                    textAlign: "center",
                    minWidth: "100px",
                  }}
                >
                  Min. SKU Qty
                </TableCell>
                {companyEditedData[0]?.value?.map((_, index) => (
                  <TableCell
                    sx={{
                      backgroundColor: "#c4c4c4",
                      textAlign: "center",
                      minWidth: "60px",
                    }}
                    key={index}
                  >
                    CV {index + 1}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {companyEditedData?.map((row, rowIndex) => (
                <TableRow key={row.id}>
                  <TableCell sx={{ textAlign: "center" }}>
                    {row.sku_names.join(", ")}
                  </TableCell>
                  <TableCell
                    sx={{ textAlign: "center", backgroundColor: "#e8e6e6ff" }}
                  >
                    <TextField
                      size="small"
                      type="number"
                      inputProps={{ min: 1 }}
                      value={row.min_sku_size}
                      onChange={(e) =>
                        handleCompanyMinSkuSizeChange(rowIndex, e.target.value)
                      }
                      error={row.min_sku_size === ""}
                      helperText={
                        row.min_sku_size === "" ? "This Field is required" : ""
                      }
                    />
                  </TableCell>
                  {row?.value?.map((val, valueIndex) => (
                    <React.Fragment key={val.id}>
                      <TableCell sx={{ textAlign: "center" }}>
                        <TextField
                          size="small"
                          type="number"
                          inputProps={{ min: 1 }}
                          value={val.creditable_value}
                          onChange={(e) =>
                            handleCompanyInputChange(
                              rowIndex,
                              valueIndex,
                              "creditable_value",
                              e.target.value
                            )
                          }
                          error={val.creditable_value === ""}
                          helperText={
                            val.creditable_value === ""
                              ? "This Field is required"
                              : ""
                          }
                        />
                      </TableCell>
                    </React.Fragment>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Stack sx={{ justifyContent: "center", marginTop: 2 }}>
          <button
            onClick={handleCompanySubmit}
            style={{
              backgroundColor: "#DC1D13",
              color: "white",
              padding: "10px 18px",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              textTransform: "none",
              width: "fit-content",
              alignSelf: "center",
            }}
          >
            <strong>Update</strong>
          </button>
        </Stack>
        <ToastContainer />
      </Stack>
    </Stack>
  );
};

export default RewardCoinsTable;